import type { FC, HTMLAttributes, ReactNode } from "react";
import { cn } from "../utilities/cn";
import { type Align, type Gap, alignClass, gapClass } from "../utilities/layout";

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
  /** Vertical gap between children (Tailwind `gap-*` scale). Defaults to 4. */
  gap?: Gap;
  /** Cross-axis (horizontal) alignment of children. */
  align?: Align;
  children: ReactNode;
}

/**
 * Vertical flex column with a token-based gap.
 * Replaces repeated `flex flex-col gap-*` wrappers.
 */
export const Stack: FC<StackProps> = ({
  gap = 4,
  align,
  className,
  children,
  ...rest
}) => (
  <div
    className={cn(
      "flex flex-col",
      gapClass[gap],
      align && alignClass[align],
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);
